import { useStorageContextSelector } from './storage';

export const usePopoversContext = () => {
  const registerUncontrolledPopover = useStorageContextSelector((context) => context.registerUncontrolledPopover);
  const showUncontrolledPopover = useStorageContextSelector((context) => context.showUncontrolledPopover);

  return { registerUncontrolledPopover, showUncontrolledPopover };
};
